import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import {
  ValidationProvider, ValidationObserver, localize, extend,
} from 'vee-validate';
import VueCurrencyInput from 'vue-currency-input';
import * as rules from 'vee-validate/dist/rules';
import ja from 'vee-validate/dist/locale/ja.json';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import { v4 } from 'uuid';
import AsyncComputed from 'vue-async-computed';
import AuhtMixin from '@/mixins/Auth.vue';
import NotificationMixin from '@/mixins/Notification.vue';
import LoadingMixin from '@/mixins/Loading.vue';
// import ErrorMixin from '@/mixins/Error.vue';
// import Raven from '@/modules/raven';
import * as stores from '@/stores/index';
// import App from './App.vue';
// import router from './router/index';

import dims from '@/rules/dimensions';

import * as firebase from '@/plugins/firebase';
firebase.init();

Vue.use(AsyncComputed);
Vue.use(VueCurrencyInput);
Vue.config.productionTip = false;

Vue.prototype.$stores = {};
Vue.prototype.$uuid = {};
Vue.prototype.$uuid.v4 = v4;

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

for (const rule in rules) {
  extend(rule, rules[rule]);
}

extend('dims', dims);

localize('ja', ja);

const requireComponent = require.context(
  // コンポーネントフォルダの相対パス
  './components',
  // サブフォルダ内を調べるかどうか
  true,
  // 基底コンポーネントのファイル名に一致させるのに使う正規表現
  /[A-Z-]\w+\.(vue)$/,
);
if (requireComponent) {
  requireComponent.keys().forEach((fileName) => {
    if (fileName) {
      // コンポーネント設定を取得する
      const componentConfig = requireComponent(fileName);
      // コンポーネント名をパスカルケース (PascalCase) で取得する
      const sc = fileName
        .split('/')
        .pop();
      if (sc) {
        const ssc = sc.replace(/\.\w+$/, '');

        const cc = camelCase(ssc);

        const componentName = upperFirst(cc);
        // コンポーネントをグローバル登録する
        if (process.env.NODE_ENV !== 'production') {
          console.log(componentName);
        }
        Vue.component(
          componentName,
          componentConfig.default || componentConfig,
        );
      }
    }
  });
}

Vue.mixin(AuhtMixin);
Vue.mixin(NotificationMixin);
Vue.mixin(LoadingMixin);

// const authStore = stores.auth;
// const loadingStore = stores.loading;
// Vue.prototype.$stores.auth = authStore;
// Vue.prototype.$stores.loading = loadingStore;
Vue.prototype.$stores = stores;
